import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Toaster, toast, ToastBar } from "react-hot-toast";
import Amplify from "aws-amplify";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { useIdle } from "react-use";

import ContextManager from "./Utility/ContextManager";
import MainRoutes from "./MainRoutes";
import { Col, Row } from "react-bootstrap";

import "react-confirm-alert/src/react-confirm-alert.css";
import "react-image-crop/dist/ReactCrop.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./assets/css/style.scss";
import "./assets/css/font-awesome.min.css";

import awsExports from "./aws-exports";
import { logOut } from "./Utility";

Amplify.configure(awsExports);

function App() {
  const isIdle = useIdle(1800000); // 30 minutes

  // define rest of the components

  useEffect(() => {
    if (isIdle) {
      console.log("User is idle");
      logOut();
    }
  }, [isIdle]);

  return (
    <div>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <Router>
          <ContextManager>
            <MainRoutes />
          </ContextManager>
        </Router>
      </MuiPickersUtilsProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 5000,
          error: {
            className: "alert error",
            icon: "⚠️",
          },
          success: {
            className: "alert success",
            icon: "✅",
          },
        }}
      >
        {(t) => (
          <ToastBar
            toast={t}
            style={{
              ...t.style,
              animation: t.visible ? "custom-enter 1s ease" : "custom-exit 1s ease",
            }}
            children={(props) => {
              return (
                <Row className="w-100">
                  <Col xl={10} className="d-flex align-items-center">
                    {t?.type === "success" ? (
                      <img
                        width={50}
                        height={50}
                        className="img"
                        style={{ fill: "green", position: "absolute" }}
                        src={require("./assets/images/icon-check-circle-green.svg").default}
                        alt="Success Icon"
                      />
                    ) : (
                      <img
                        width={35}
                        height={35}
                        className="img"
                        style={{ fill: "red" }}
                        src={require("./assets/images/icon-cross-red.svg").default}
                        alt="Error Icon"
                      />
                    )}
                    <div style={{ marginTop: "5px", marginLeft: t?.type === "success" ? "50px" : "5px" }}>
                      <div>
                        {
                          <strong style={{ fontSize: "20px", marginTop: "25px", marginLeft: "10px" }}>
                            {t?.type === "success" ? "Success" : "Error"}
                          </strong>
                        }
                      </div>
                      <span style={{ color: "gray", float: "left" }}>{props.message}</span>
                    </div>
                  </Col>
                  <Col xl={2} md={12} xs={12} className="d-flex align-items-center justify-content-end">
                    <span
                      className="pointer"
                      style={{ color: "gray", marginLeft: "25px", cursor: "pointer" }}
                      onClick={() => toast.dismiss(t.id)}
                    >
                      CLOSE
                      {/*props.icon*/}
                    </span>
                  </Col>
                </Row>
              );
            }}
          />
        )}
      </Toaster>
    </div>
  );
}

export default App;
